// shared/application/useAsistentesEditor.js  (asistentes seleccionados + catálogo de productores). Sin JSX ni Swal.
import { useCallback, useMemo, useState } from 'react';
import { catalogosRepository } from '../infrastructure/catalogos.repository';
import { useCatalogo } from './useCatalogo';
import { useFotosProductores } from './useFotosProductores';
import { productoresDisponibles, resolverProductores } from '../domain/productor';

/**
 * `initialIds`: ids de cuenta cargados (solo se leen al montar; el hijo se monta con la entidad ya cargada).
 * Contrato: { data: seleccionados enriquecidos, ids, options, fotos, status, error, add, remove }
 */
export const useAsistentesEditor = ({ initialIds = [], idCiclo = null, catalogos = catalogosRepository, productoresRepo } = {}) => {
  const [ids, setIds] = useState(initialIds);
  const productores = useCatalogo(() => catalogos.productores(idCiclo), [catalogos, idCiclo]);

  const data = useMemo(() => resolverProductores(ids, productores.data), [ids, productores.data]);
  const uuids = useMemo(() => data.map(p => p.uuid), [data]);
  const { fotos } = useFotosProductores(uuids, productoresRepo ? { repository: productoresRepo } : undefined);
  const options = useMemo(() => productoresDisponibles(productores.data, ids), [productores.data, ids]);

  const add = useCallback(id => setIds(prev => (prev.includes(id) ? prev : [...prev, id])), []);
  const remove = useCallback(id => setIds(prev => prev.filter(x => x !== id)), []);

  return { data, ids, options, fotos, status: productores.status, error: productores.error, add, remove };
};

export default useAsistentesEditor;
